import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import ElementUI  from 'element-ui'
import './assets/style/element.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import './permission'

Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false;

Vue.prototype.$showLoginPopup = () => {
    store.commit('user/openLoginPopup')
}

Vue.prototype.$hideLoginPopup = ()=> {
    store.commit('user/hideLoginPopup')
}

Vue.prototype.$showUserInfo = ()=> {
  store.commit('user/userInfo')
}



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
